export interface CaseListFunderOptions {
   fundingPrograms: string[];
}